import React from 'react';
import type { ReactNode } from 'react';
import { WhiteLabelThemeProvider } from '../SolvThemeProvider';
import { whiteLabelPalettes } from '../../theme/whiteLabelColors';

export type CustomColorPaletteProps = {
  /** The content to apply the new brand color to */
  children?: ReactNode;

  /** The name of the custom color palette */
  palette: keyof typeof whiteLabelPalettes;
};

/**
 * Applies a custom brand color palette to child components
 */
const CustomColorPalette = ({ children, palette }: CustomColorPaletteProps) => {
  return (
    <WhiteLabelThemeProvider theme={palette}>
      {children}
    </WhiteLabelThemeProvider>
  );
};

CustomColorPalette.displayName = 'CustomColorPalette';
export default CustomColorPalette;
